import * as React from "react";
const SvgFiRrSteak = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-steak_svg__a)">
      <path
        fill="#062147"
        d="M17.5 24a5.77 5.77 0 0 1-4.719-2.238A4.34 4.34 0 0 0 9 20c-4.794 0-9-4.673-9-10A10.01 10.01 0 0 1 10 0c9.772 0 14 11.588 14 17.5a6.51 6.51 0 0 1-6.5 6.5M10 2C-.468 2.379-.38 17.105 9 18a6.3 6.3 0 0 1 5.242 2.4c2.336 3.251 7.858 1.173 7.758-2.9C22 12.938 18.547 2 10 2M6.707 13.707l7-7a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 1.414 1.414m4 2 6-6a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0 1.414 1.414m4 2 4-4a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 1.414 1.414m4 2 1-1a1 1 0 0 0-1.414-1.414l-1 1a1 1 0 0 0 1.414 1.414m-13-11 3-3a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-steak_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSteak;
